module.exports = __webpack_public_path__ + "img/gan_no.fcb2ae21.png";